import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, FormControl, FormHelperText, Grid, TextField } from '@mui/material';
import SlotResultPage from './SlotResultPage';
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment';
import { CampaignAdvertisement } from '@horasys/bellplus/common/types';
import { validateSchema } from 'validations/common';
import { autoModeValidation } from 'validations/campaign.validation';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { CampaignState, getMainLocationAutoResult } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
import { CssTextField } from 'views/Common/CssTextField';

const PREFIX = 'LocationAutoMode';

const classes = {
    formElement: `${PREFIX}-formElement`,
    paperchildGrid: `${PREFIX}-paperchildGrid`,
    allocateSlotButton: `${PREFIX}-allocateSlotButton`,
    slotResultsPage: `${PREFIX}-slotResultsPage`
};
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formElement}`]: {
        minWidth: '100%',
    },

    [`& .${classes.paperchildGrid}`]: {
        padding: theme.spacing(1),
    },

    [`& .${classes.allocateSlotButton}`]: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(3),
    },

    [`& .${classes.slotResultsPage}`]: {
        marginTop: theme.spacing(3),
        height: '100%',
        padding: theme.spacing(3),
    }
}));

interface LocationAutoModeProps {
	campaignAdvertisement: CampaignAdvertisement;
	handleFormChange: any;
	isViewMode: boolean;
	error: any;
	setError: any;
}

export const LocationAutoMode = (props: LocationAutoModeProps) => {
	const { handleFormChange, isViewMode, error, setError } = props;

	const dispatch = useAppDispatch();
	const campaignStore: CampaignState = useAppSelector((state: RootState) => state.campaign);
	const {
		campaignAdvertisementForm: campaignAdvertisement,
		currentSlotResults: slotResults,
	} = campaignStore;

	const handleAllocateSlots = async () => {
		const requestObj = {
			startDate: moment(campaignAdvertisement.startDate).format('YYYY-MM-DD'),
			endDate: moment(campaignAdvertisement.endDate).format('YYYY-MM-DD'),
			advertisementId: campaignAdvertisement.advertisement.id,
			budget: campaignAdvertisement.userBudget,
			noOfTimes: campaignAdvertisement.noOfTimes,
			areas: campaignAdvertisement.selectedAreas,
			uuid: campaignAdvertisement.uuid,
		};
		try {
			console.warn(requestObj);
			await validateSchema(autoModeValidation, requestObj);
			setError({});
			dispatch(getMainLocationAutoResult(requestObj));
		} catch (error) {
			console.warn('ERROR', error);
			setError(error);
		}
	};

	return (
        <Root>
            <Grid item container xs={12}>
                <Grid item container xs={6} className={classes.paperchildGrid}>
                    <FormControl variant="outlined" className={classes.formElement}>
                        <CssTextField
                            label="Enter Budget"
                            name="budget"
                            variant="outlined"
                            id="budget"
                            required
                            fullWidth
                            autoComplete="off"
                            value={campaignAdvertisement.userBudget}
                            onChange={handleFormChange}
                            disabled={isViewMode}
                        />
                        {error && error.budget && (
                            <FormHelperText error={true}>{error.budget}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item container xs={6} className={classes.paperchildGrid}>
                    <FormControl variant="outlined" className={classes.formElement}>
                        <CssTextField
                            label="No. of times"
                            name="noOfTimes"
                            variant="outlined"
                            id="noOfTimes"
                            required
                            fullWidth
                            autoComplete="off"
                            value={campaignAdvertisement.noOfTimes}
                            onChange={handleFormChange}
                            disabled={isViewMode}
                        />
                        {error && error.noOfTimes && (
                            <FormHelperText error={true}>
                                {error.noOfTimes}
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                <Grid item container xs={12} justifyContent="center">
                    <Button
                        disabled={isViewMode}
                        className={classes.allocateSlotButton}
                        variant="outlined"
                        style={{color:'#042630'}}
                        endIcon={<SearchIcon />}
                        onClick={handleAllocateSlots}>
                        Allocate slots
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} className={classes.slotResultsPage}>
                <SlotResultPage slotResults={slotResults.locations} />
            </Grid>
        </Root>
    );
};
